const styles = () => ({
  '.MuiSwitch-root': {
    padding: '4px',
    width: '80px',
    '.MuiSwitch-switchBase': {
      padding: '6px',
      color: '#ababab',
      '& + .MuiSwitch-track': {
        background: '#F2F2F2 !important',
        opacity: '1 !important',
        borderRadius: '500px',

        '&:before': {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 16,
          height: 16,
          fontWeight: '700',
          fontSize: '14px',
          lineHeight: '16px',
          color: '#000000',
          fontFamily: 'Inter',
          right: '27px',
          left: 'auto',
        },
      },
      '.MuiSvgIcon-root': {
        width: '25px',
        height: '25px',
      },
      '&.Mui-checked': {
        color: '#00c738 !important',
        transform: 'translateX(43px)',

        '& + .MuiSwitch-track': {
          background: '#D1FCEB !important',
          '&:before': {
            left: '15px',
            right: 'auto',
          },
        },

        '&.Mui-disabled': {
          opacity: '0.5 !important',
          '& + .MuiSwitch-track': {
            opacity: '0.5 !important',
          },
        },
      },
    },
  },

  '&.dn-small .MuiSwitch-root': {
    width: '60px',
    '.MuiSwitch-switchBase': {
      '&.Mui-checked': {
        transform: 'translateX(23px)',
      },
    },
  },
});

export default styles;
